import React from 'react';

export default function FB() {
  return (
    <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 .219C23.164.219 29.782 6.836 29.782 15c0 8.164-6.618 14.782-14.782 14.782S.219 23.164.219 15 6.836.219 15 .219zm1.48 7.39c-2.206 0-3.647 1.281-3.647 3.6v2.04H10.38v2.675h2.452v6.467h3.017v-6.467h2.25l.429-2.675H15.85v-1.736c0-.732.374-1.445 1.574-1.445h1.218V7.79s-1.105-.18-2.162-.18z"
        fill="#3B5998"
      />
    </svg>
  );
}
